<app-base-notification [base]="base">
  <div [innerHTML]="'notifications.meeting_purchase_was_canceled.text' | customLocale: {'title': title}"></div>
</app-base-notification>

